import { LOANREQUEST_BUCKETS, TEAM_CATEGORIES } from 'cpool-constants';
import type { LOANREQUEST_BUCKET, TEAM_CATEGORY } from 'cpool-constants';

export type CategoryByUserId = Partial<Record<string, TEAM_CATEGORY | null>>;

export const getMaxAssignedUsers = (bucket: LOANREQUEST_BUCKET | null) =>
    bucket === LOANREQUEST_BUCKETS.IK ? Object.keys(TEAM_CATEGORIES).length : 1;

export const hasMultipleAssignedUsers = (bucket: LOANREQUEST_BUCKET | null) => getMaxAssignedUsers(bucket) > 1;

// a user whose slot category is stored for the lead wins over one matching only via their current team
export const findSlotHolder = ({
    category,
    categoryByUserId,
    slotCategories = {},
    userIds,
}: {
    category: TEAM_CATEGORY;
    categoryByUserId: CategoryByUserId;
    slotCategories?: CategoryByUserId;
    userIds: string[];
}) =>
    userIds.find((id) => slotCategories[id] === category) ??
    userIds.find((id) => categoryByUserId[id] === category) ??
    null;

export const pickResponsibleUserId = ({
    categoryByUserId,
    slotCategories,
    userIds,
}: {
    categoryByUserId: CategoryByUserId;
    slotCategories?: CategoryByUserId;
    userIds: string[];
}) =>
    findSlotHolder({ category: TEAM_CATEGORIES.MARKTFOLGE_BANK, categoryByUserId, slotCategories, userIds }) ??
    userIds[0] ??
    null;

export const getActiveOrFirstUserId = ({
    activeUserId,
    userIds,
}: {
    activeUserId?: string | null;
    userIds: string[];
}) => activeUserId ?? userIds[0] ?? null;
